import React, { ReactNode } from 'react';

export const boldText = {
  b: (chunks: ReactNode) => <b>{chunks}</b>,
};

export const boldItalicText = {
  b: (chunks: ReactNode) => (
    <strong>
      <em>{chunks}</em>
    </strong>
  ),
};
